import { Inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { APP_CONFIG } from '../app.config';
import { AppConfig } from '../models/app.config';
import { AllocationRequest } from 'src/app/pages/allocation/models/allocation-request';
import { Observable } from 'rxjs';
import { UndoAllocationRequest } from 'src/app/pages/allocation/models/undo-allocation-request';

@Injectable({
  providedIn: 'root'
})
export class AllocationService {

  private readonly accountEndpointUrl: string = "allocation/";
  config: AppConfig;

  constructor(private apiService: ApiService, @Inject(APP_CONFIG) config: AppConfig,) {
      this.config = config;
  }


  public createTradeAllocation(elements: AllocationRequest[]): Observable<AllocationRequest[]> {
      return this.apiService.post<AllocationRequest[]>(`${this.accountEndpointUrl}`, JSON.stringify(elements));
  }


  public undoTradeAllocation(elements: UndoAllocationRequest[]): Observable<UndoAllocationRequest[]> {
    return this.apiService.post<UndoAllocationRequest[]>(`${this.accountEndpointUrl}Undo`, JSON.stringify(elements));
}
}
